export default __webpack_public_path__ + "static/media/logo.69b32cb7.jpg";